import { createSlice } from '@reduxjs/toolkit';




const initialState = {
  rawItems: [], // Initialize rawItems as an empty array
};

export const  rawItemsDetailById =(id)=>{
  // let product = initialState.rawItems.find((item)=>item.id+""===id+"")
  // return product
}

export const rawItemsSlice = createSlice({
  name: 'rawItems',
  initialState,
  reducers: {
    setRawItems: (state, action) => {
      state.rawItems = action.payload; // Ensure payload is spread correctly
    },
    clearRawItemsState: (state) => {
      state=initialState
    }
  }
});

export const { setRawItems, clearRawItemsState } = rawItemsSlice.actions;

export const rawItemsData = (state) => state.rawItems.rawItems;

export default rawItemsSlice.reducer;
